import React, { useState } from 'react';
import { Question } from '../../types/models';
import { questionService, CreateQuestionData } from '../../services/questionService';
import { EditQuestionForm } from './EditQuestionForm';
import { Button } from '../common/Button';
import './QuestionList.css';

type QuestionListProps = {
  questions: Question[];
  onQuestionUpdated?: (updated: Question) => void;
};

export const QuestionList = ({ questions, onQuestionUpdated }: QuestionListProps) => {
  const [editingId, setEditingId] = useState<string | null>(null);
  const [isSaving, setIsSaving] = useState(false);

  const handleEdit = (id: string) => setEditingId(id);
  const handleCancel = () => setEditingId(null);

  const handleSave = async (id: string, data: Partial<CreateQuestionData>) => {
    setIsSaving(true);
    try {
      const updated = await questionService.updateQuestion(id, data);
      if (onQuestionUpdated) onQuestionUpdated(updated);
      setEditingId(null);
    } catch (e) {
      alert('Błąd podczas edycji pytania.');
    } finally {
      setIsSaving(false);
    }
  };

  if (questions.length === 0) {
    return <p>Nie dodałeś jeszcze żadnych pytań.</p>;
  }

  return (
    <div className="question-list-container">
      <h3>Twoja baza pytań:</h3>
      <ul>
        {questions.map((q) => (
          <li key={q.id} className="question-item">
            {editingId === q.id ? (
              <EditQuestionForm
                question={q}
                onSave={async (data) => handleSave(q.id, data)}
                onCancel={handleCancel}
              />
            ) : (
              <>
                <p className="question-text">{q.text}</p>
                {q.imageUrl && <img src={q.imageUrl} alt="Pytanie" className="question-image" />}
                <span className={q.correctOptions.includes('A') ? 'correct' : ''}>A: {q.optionA}</span>
                <span className={q.correctOptions.includes('B') ? 'correct' : ''}>B: {q.optionB}</span>
                <span className={q.correctOptions.includes('C') ? 'correct' : ''}>C: {q.optionC}</span>
                <Button style={{ marginLeft: 8 }} onClick={() => handleEdit(q.id)} disabled={isSaving}>Edytuj</Button>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};